import type { AnnotationUpdateEmitter } from '@atlaskit/editor-common/annotation';
import { AnnotationUpdateEvent } from '@atlaskit/editor-common/types';

import { fg } from '@confluence/feature-gating';
import { PageMode } from '@confluence/page-utils/entry-points/enums.ts';

export type CommentThreadMouseEnterParams = {
	id?: string;
	threadKey?: string;
	setIsThreadHovered: React.Dispatch<React.SetStateAction<boolean>>;
	setHoveredCommentId: React.Dispatch<React.SetStateAction<string | undefined>>;
	pageMode: PageMode;
	eventEmitter?: AnnotationUpdateEmitter;
};

export const handleCommentThreadMouseEnter = ({
	id,
	threadKey,
	setIsThreadHovered,
	setHoveredCommentId,
	pageMode,
	eventEmitter,
}: CommentThreadMouseEnterParams) => {
	if (threadKey) {
		setIsThreadHovered(true);
		id && setHoveredCommentId(id);
		if (fg('confluence_frontend_comments_panel_v2')) {
			if (pageMode === PageMode.EDIT || pageMode === PageMode.LIVE) {
				eventEmitter?.emit('sethoveredannotation', threadKey);
			} else {
				eventEmitter?.emit(AnnotationUpdateEvent.SET_ANNOTATION_HOVERED, {
					annotationId: threadKey,
				});
			}
		}
	}
};

export const handleCommentThreadMouseLeave = ({
	threadKey,
	setIsThreadHovered,
	setHoveredCommentId,
	pageMode,
	eventEmitter,
}: CommentThreadMouseEnterParams) => {
	if (threadKey) {
		setIsThreadHovered(false);
		setHoveredCommentId(undefined);
		if (pageMode === PageMode.EDIT || pageMode === PageMode.LIVE) {
			eventEmitter?.emit('removehoveredannotation', threadKey);
		} else {
			eventEmitter?.emit(AnnotationUpdateEvent.REMOVE_ANNOTATION_HOVERED, {
				annotationId: threadKey,
			});
		}
	}
};
